import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

function BarInfo(props) {
  const {
    barInfoActive,
    barInfo,
    learnModeOpen
  } = props

  return (
    <div className={ classnames('bar-info', {'active': learnModeOpen || barInfoActive}) }>
      {barInfo}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    barInfo: state.editor.barInfo,
    barInfoActive: state.editor.barInfoActive,
    learnModeOpen: state.editor.learnModeOpen
  }
}

export default connect(mapStateToProps)(BarInfo)
